import { Clock3Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Chip } from '@/components/atoms/Chip/Chip';
import useBrains from '@/hooks/useBrains';
import { selectSelectedNode } from '@/redux/dialogs/selectors';
import { selectBrainId } from '@/redux/session/selectors';

export const AssignedReminders = () => {
  // Redux selectors
  const brainId = useSelector(selectBrainId);
  const selectedNode = useSelector(selectSelectedNode);

  // Custom hooks
  const { t } = useTranslation();
  const { brain } = useBrains(brainId);

  // Local variables
  const nodeId = selectedNode?.node_id;
  const reminders = brain?.guidelines?.reminders || [];
  const numberedReminders = reminders
    .map((reminder, index) => ({ ...reminder, number: index + 1 }))
    .filter((reminder) => reminder.node_id === nodeId);
  const isNodeWithReminders = numberedReminders.length > 0;

  if (!isNodeWithReminders) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Clock3Icon size="16" />
      <span className="text-sm leading-5 font-normal">{t('conversation.assigned_to')}</span>

      {numberedReminders.map((reminder) => (
        <Chip key={reminder.number}>{`${t('ai_agents.reminder.timer')} ${reminder.number}`}</Chip>
      ))}
    </div>
  );
};
